export default "__VITE_ASSET__3dd17855__"